import React, {useEffect, useRef, useState} from 'react';
import userCircle from '../../../../assets/icons/UserCircle.png'
import arrowWhite from '../../../../assets/icons/arrow_down_white.png'
import changeUser from '../../../../assets/icons/change_user.png'
import exit from  '../../../../assets/icons/exit.png'

import LoginModal from '../modals/loginModal';

import {useTranslation} from 'react-i18next';
import ChooseRoleModal from '../modals/ChooseRoleModal';
import {useDispatch, useSelector} from "react-redux";
import {logOut} from "../../../../store/reducers/authSlice";
import {clearUser} from "../../../../store/reducers/userSlice";

function AuthPanel({role}) {
    const isAuth = useSelector(store=>store.auth.isAuth)
    const activeRole = useSelector(store=>store.user.activeRole);
    const firstname = useSelector(store=>store.user.firstname);
    const lastname = useSelector(store=>store.user.lastname);
    const dispatch = useDispatch();
    const [isLoginModal, setIsLoginModal] = useState(false);
    const [isChooseRoleModal, setIsChooseRoleModal] = useState(false);
    const [isClicked, setIsClicked] = useState(false);

    const menuRef = useRef(null);
    const user = {
        firstname,
        lastname,
        roles: ['teacher, private_user', activeRole],
        activeRole
    }

    const handleClick = (e) => {
        if (menuRef.current && !menuRef.current.contains(e.target)) {
            setIsClicked(false);
        }
    }

    const {t} = useTranslation();

    useEffect(() => {
        document.addEventListener('mousedown', handleClick)
    }, []);
    return (
        <>
            {isAuth
                ? (
                    <div>
                        <div className="flex flex-row py-2 pr-14">
                            <div className="flex items-center mr-2">
                                <img src={userCircle} alt='user'/>
                            </div>
                            <div className="flex flex-col">
                                <div className="text-white">{user.lastname} {user.firstname}</div>
                                <div className="text-xs text-white">{t(`general.models.auth.roleType.${role}`)}</div>
                            </div>
                            <div className="flex items-center ml-2 hover:cursor-pointer" onClick={() => {
                                setIsClicked(true)
                            }}>
                                {isClicked ? <img src={arrowWhite} className="rotate-180" alt="arrow"/> :
                                    <img src={arrowWhite} alt="arrow"/>}
                            </div>
                        </div>
                        <div
                            className={`${isClicked ? '' : 'hidden'} bg-black1 p-3 w-56 rounded-lg fixed text-white mt-3 z-20`}
                            ref={menuRef}>
                            {user.roles.length > 1 && (
                                <p
                                    className="my-1 hover:cursor-pointer flex justify-between"
                                    onClick={() => {
                                        setIsChooseRoleModal(prev => !prev)
                                    }}
                                >
                                    {t('general.header.role')}
                                    <img alt={'changeRole'} src={changeUser}/>
                                </p>
                            )}

                            <p
                                className="my-1 hover:cursor-pointer flex justify-between" onClick={() => {
                                 dispatch(logOut())
                                 dispatch(clearUser())
                            }}>
                                {t('general.header.exit')}
                                <img src={exit} alt={'exit'}/>
                            </p>
                        </div>

                        <ChooseRoleModal
                            isChooseRoleModal={isChooseRoleModal}
                            setIsChooseRoleModal={setIsChooseRoleModal}
                        />

                    </div>

                )
                : (
                    <>
                        <button
                            className=" p-[12px] rounded-lg bg-orange1 text-white mr-[36px] my-1 flex gap-2 items-center tablet:mr-[0px]"
                            onClick={() => setIsLoginModal(true)}>
                            <img src={userCircle} alt={'profile'} className={'h-6 w-6'}></img>
                            {t('general.header.logIn')}
                        </button>

                        <LoginModal
                            isLoginModal={isLoginModal}
                            setIsLoginModal={setIsLoginModal}
                            isAuth={isAuth}
                            isClicked={isClicked}
                            setIsClicked={setIsClicked}
                            setIsChooseRoleModal={setIsChooseRoleModal}
                        />

                    </>

                )
            }
        </>
    );
}

export default AuthPanel;
